import { BILLING_PERIODS, type BillingPeriod } from '@pulsify/shared/dto'
import * as m from '~/paraglide/messages'
import { cn } from '~/shared/lib/utils'
import { billingPeriodLabel } from '../plans'

interface BillingPeriodSwitchProps {
  value: BillingPeriod
  onChange: (period: BillingPeriod) => void
}

export function BillingPeriodSwitch({ value, onChange }: BillingPeriodSwitchProps) {
  return (
    <fieldset className="squircle inline-flex items-center gap-1 rounded-xl border bg-muted p-1">
      <legend className="sr-only">{m.billingPeriod()}</legend>
      {BILLING_PERIODS.map((period) => {
        const selected = period === value
        return (
          <button
            key={period}
            type="button"
            aria-pressed={selected}
            onClick={() => onChange(period)}
            className={cn(
              'squircle rounded-lg px-3 py-1.5 text-xs transition-colors sm:px-4 sm:text-sm',
              'motion-reduce:transition-none',
              'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
              selected
                ? 'bg-card font-medium text-foreground shadow-[0_1px_2px_rgb(10_10_11/0.08)]'
                : 'text-muted-foreground hover:text-foreground',
            )}
          >
            {billingPeriodLabel(period)}
          </button>
        )
      })}
    </fieldset>
  )
}
